$(function() {
  'use strict';

  var runtime = false;

  // 通報ボタン押下
  $('.comment-report').on('click',  function(event) {
    event.preventDefault();

    if (!confirm('不適切なコメントとして通報してもよろしいですか？')) { 
      return false;
    }

    var repBtn = $(this);
    repBtn.prop('disabled', true);

    $.ajax({
      url: moko.ajaxurl,
      type: 'POST',
      dataType: 'text',
      timeout: 10000,
      cache : false,
      data: {
        'action': 'comment_report',
        '_ajax_nonce': repBtn.data('nonce'),
        'comment_id': repBtn.data('comment-id'),
        'site_url' : repBtn.data('site-url')
      }
    }).
      always(function() {
        repBtn.prop('disabled', false);
      }).
        fail(function(xhr, status, error) {
          console.log('failed: ' + status + ' ' + xhr.status + ' ' + xhr.statusText);
          alert('通信エラー');
        }).
          done(function(data) {
            data = data.trim();
            console.log(data);
            if (data === 'OK') {
              alert('コメントを通報しました');
            } else if (data === 'Existing') {
              alert('既に通報しています');
            } else {
              alert('送信に失敗しました');
            }
          });
  });
});
